/*
 * O seletor de emoji é um chunk sob demanda: os botões chamam estas versões,
 * e o ponteiro ou o foco no botão já pede o chunk (o clique quase sempre o
 * encontra pronto). Os dados dos emoji são outro chunk, que o seletor pede.
 */
import { once } from '../../../utils/chunkGate';
const load = once(() => import(/* webpackChunkName: 'forum/features/composer/emoji/EmojiPicker', webpackMode: 'lazy-once' */ './EmojiPicker'));
export function preloadEmojiPicker() {
  load().catch(() => {});
}
export function openEmojiPicker(anchor, onselect) {
  load().then(picker => picker.openEmojiPicker(anchor, onselect));
}
flarum.reg.add('ramon-canela', 'forum/features/composer/emoji/pickerLazy', { preloadEmojiPicker: preloadEmojiPicker,openEmojiPicker: openEmojiPicker, });flarum.reg.addChunkModule('forum/features/composer/emoji/EmojiPicker', './src/forum/features/composer/emoji/EmojiPicker.tsx', 'ramon-canela', 'forum/features/composer/emoji/EmojiPicker');